import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { getCampaignTypeList } from 'features/CampaignAndDiscount/services/campaignList'
import {
  getCampaignBMSMDownloadSKU,
  GetCampaignBMSMDownloadSKURequestType,
} from 'features/CampaignAndDiscount/services/campaignAddEdit'
import { SLICE_NAME, setLoading } from './slice'

export const fetchCampaignTypeList = createAsyncThunk(
  `${SLICE_NAME}/getCampaignTypeList`,
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCampaignTypeList()
      return res.data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const fetchCampaignBMSMDownloadSKU = createAsyncThunk(
  `${SLICE_NAME}/fetchCampaignBMSMDownloadSKU`,
  async ({ params, id }: GetCampaignBMSMDownloadSKURequestType, { rejectWithValue, dispatch }) => {
    dispatch(setLoading(true))
    try {
      const res = await getCampaignBMSMDownloadSKU({ params, id })
      dispatch(setLoading(false))

      return res.data.data
    } catch (err) {
      callErrorMsg(err)
      dispatch(setLoading(false))

      return rejectWithValue(err)
    }
  },
)
